/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (resolves the custom-module JSON blob for a product/date)
 *   extends:   Component (@glimmer/component)
 *   template:  custom-modules.hbs
 *   args:      @custom_date, @item
 *   uses:      service session
 *   siblings:  -
 *   tests:     storefront-components-test.js
 *
 * Picks the moduli JSON to render: an explicit @custom_date override, else the
 * product item's own modules_json.moduli.
 */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class CustomModulesComponent extends Component {
  @service session;

  get customData() {
    return this.args.custom_date || this.args.item?.modules_json?.moduli;
  }
}
